/* Verified Shopify total and a rolling 24-hour aggregate from order reporting. */
(() => {
  'use strict';
  const box=document.querySelector('[data-ptf-impact]');
  if(!box)return;
  const value=box.querySelector('[data-ptf-count]'),spoken=box.querySelector('[data-ptf-count-label]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const format=new Intl.NumberFormat('de-DE');
  let target=0,displayed=0,entered=false,frame=0,initialized=false,hasLiveTotal=false;
  function number(input){
    if(typeof input==='number')return Number.isSafeInteger(input)&&input>0?input:0;
    const text=String(input??'').trim();
    if(!/^\d+(?:[.,\s]\d{3})*$/.test(text))return 0;
    const n=Number(text.replace(/[.,\s]/g,''));return Number.isSafeInteger(n)&&n>0?n:0;
  }
  function draw(n){displayed=n;value.textContent=format.format(n);}
  function animate(from,to){
    cancelAnimationFrame(frame);
    if(reduced.matches){draw(to);return;}
    const start=performance.now(),duration=initialized?650:1700;
    const tick=now=>{const t=Math.min(1,(now-start)/duration);draw(Math.round(from+(to-from)*(1-Math.pow(1-t,3))));if(t<1)frame=requestAnimationFrame(tick);};
    frame=requestAnimationFrame(tick);
  }
  function update(raw,verified=false){
    if(hasLiveTotal&&!verified)return;
    const n=number(raw);if(!n)return;
    if(verified)hasLiveTotal=true;
    if(n===target)return;
    target=n;box.dataset.count=String(n);box.hidden=false;
    spoken.textContent=format.format(n)+' Bäume haben wir gemeinsam bereits gepflanzt.';
    if(entered){animate(displayed,target);initialized=true;}else draw(target);
  }
  function enter(){if(entered)return;entered=true;animate(0,target);initialized=true;}
  update(box.dataset.count);
  window.addEventListener('pt:treecount',event=>{const d=event.detail;update(d?.count??d?.value??d?.live_count??d?.liveCount??d);},{passive:true});
  function bindQuick(){const quick=document.getElementById('pt-quick-b2c');if(!quick)return false;update(quick.getAttribute('data-live-tree-count'));new MutationObserver(()=>update(quick.getAttribute('data-live-tree-count'))).observe(quick,{attributes:true,attributeFilter:['data-live-tree-count']});return true;}
  if(!bindQuick()){const mount=document.getElementById('pt-quick-home-shogun-mount');if(mount){const observer=new MutationObserver(()=>{if(bindQuick())observer.disconnect();});observer.observe(mount,{childList:true,subtree:true});}}
  if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){enter();observer.disconnect();}},{threshold:.2});observer.observe(box);}else enter();
  reduced.addEventListener?.('change',()=>{if(reduced.matches){cancelAnimationFrame(frame);draw(target);}});

  const recent=box.querySelector('[data-ptf-recent]');
  if(recent){
    const recentCount=recent.querySelector('[data-ptf-recent-count]');
    const recentUnit=recent.querySelector('[data-ptf-recent-unit]');
    let busy=false,lastGood=0;
    async function refreshRecent(){
      if(busy||document.hidden)return;
      busy=true;
      const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),8000);
      try{
        const response=await fetch('https://partner.planet-tree.de/api2/forest/recent-trees',{credentials:'omit',signal:controller.signal});
        if(!response.ok)throw new Error('Unavailable');
        const data=await response.json();
        const fresh=Number.isFinite(data.updated_at)&&Math.abs(Date.now()/1000-data.updated_at)<120;
        if(fresh&&Number.isSafeInteger(data.total)&&data.total>0)update(data.total,true);
        if(!data.available||!fresh||data.window_hours!==24||!Number.isSafeInteger(data.trees)||data.trees<0){recent.hidden=true;lastGood=0;return;}
        recentCount.textContent=(data.trees>0?'+':'')+format.format(data.trees);
        recentUnit.textContent=data.trees===1?'Baum':'Bäume';
        recent.hidden=false;lastGood=Date.now();
      }catch(_){if(Date.now()-lastGood>120000)recent.hidden=true;}
      finally{clearTimeout(timeout);busy=false;}
    }
    refreshRecent();
    setInterval(refreshRecent,60000);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden){if(Date.now()-lastGood>120000)recent.hidden=true;refreshRecent();}});
  }
})();
